export default angular.module("mars.vet.dnareports.controllers.learnmoretraits",[]).controller('LearnMoreTraitsController', function($rootScope, $scope, $routeParams, $window, EntryService, EntryIDService, NavigationService) {


    EntryService.getEntry(EntryIDService.getEntryID('LearnMoreTraits')).then(function(response) {
        var fields = response.fields;
        $rootScope.pageTitle = fields.title;
        $scope.traitTypes = fields.traits.traitTypes;
        $window.ga('send', 'pageview', {
            'page': $rootScope.pageTitle
        });
        NavigationService.setNavigationUrls();
    });

}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/learnmoretraits.controller.js